import React from 'react';
import { Sparkle } from '../common/Sparkle';
export function About() {
  return <section id="about" className="py-20 md:py-32 bg-brand-gray" data-id="element-59">
      <div className="container mx-auto px-4 md:px-6" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-61">
          {/* Left Column: Mascot */}
          <div className="order-2 lg:order-1 flex justify-center" data-id="element-62">
            <div className="bg-brand-sky rounded-[3rem] p-8 md:p-16 relative w-full max-w-md aspect-square flex items-center justify-center shadow-sm" data-id="element-63">
              <Sparkle className="absolute top-8 right-8 h-8 w-8 text-brand-white opacity-50" data-id="element-64" />
              <Sparkle className="absolute bottom-12 left-8 h-6 w-6 text-brand-white opacity-50" data-id="element-65" />
              <img src="https://cdn.magicpatterns.com/uploads/gtD1cnnHQnJHdEWphpETGZ/deep-clean-logo.png" alt="Deep Clean Cleaners Mascot" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-66" />
            </div>
          </div>

          {/* Right Column: Content */}
          <div className="order-1 lg:order-2 flex flex-col items-start text-center lg:text-left" data-id="element-67">
            <span className="text-brand-aqua font-bold tracking-wider uppercase text-sm mb-4 flex items-center gap-2 mx-auto lg:mx-0" data-id="element-68">
              <Sparkle className="h-4 w-4" data-id="element-69" />
              Committed to Cleanliness
            </span>

            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-navy mb-6 leading-tight" data-id="element-70">
              A Cleaner Home Starts Here
            </h2>

            <p className="text-lg text-brand-navy/80 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-71">
              At Deep Clean Cleaners, we treat every space like it's our own.
              From a routine refresh to a full move-out scrub, our team brings
              detail, care, and a spotless finish to every job. No shortcuts.
              Just clean.
            </p>

            {/* Stat Badges */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 w-full" data-id="element-72">
              <div className="bg-brand-white px-6 py-3 rounded-full shadow-sm border border-brand-sky/30 text-brand-navy font-semibold flex items-center gap-2" data-id="element-73">
                <span className="text-brand-aqua text-xl" data-id="element-74">★</span> 5-Star
                Service
              </div>
              <div className="bg-brand-white px-6 py-3 rounded-full shadow-sm border border-brand-sky/30 text-brand-navy font-semibold flex items-center gap-2" data-id="element-75">
                <span className="text-brand-aqua text-xl" data-id="element-76">⏱</span> 24/7 Booking
              </div>
              <div className="bg-brand-white px-6 py-3 rounded-full shadow-sm border border-brand-sky/30 text-brand-navy font-semibold flex items-center gap-2" data-id="element-77">
                <span className="text-brand-aqua text-xl" data-id="element-78">✓</span> 100%
                Satisfaction
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}